import { Box, Grid, Link, Skeleton, Stack, styled, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import Image from '../../components/Image';
import { HEADER } from '../../config';
import useLocales from '../../hooks/useLocales';
import GameContainer from './GameContainer';
import { calculateFontSize } from '../../utils/formatString';
import HomeLeaderboard from './HomeLeaderboard';
import useResponsive from '../../hooks/useResponsive';
import { SectionHeader, SectionIconWrapper, SectionTitle } from '../../layouts/GlobalStyles';
import { useSelector } from '../../redux/store';
import { getGameCategIcon } from '../../utils/formatObject';
import Iconify from '../../components/Iconify';

const HomeBody = ({ isLoadingGames, popularGames }) => {
  const { translate } = useLocales();

  const isDesktop = useResponsive('up', 'sm');

  const { gameCategsAndCompanies } = useSelector((x) => x.lookup);

  const params = useParams();

  const selectedCompanyCateg = useMemo(() => {
    if (params?.section && gameCategsAndCompanies?.length) {
      const companiesByCateg = gameCategsAndCompanies.find((x) => x.slug === params?.section);

      if (companiesByCateg) {
        return companiesByCateg;
      }
    }

    return '';
  }, [params?.section, gameCategsAndCompanies]);

  return (
    <>
      {!selectedCompanyCateg ? (
        <>
          {!isDesktop && <Image src={require('../../assets/home/home-banner.png')} sx={{ width: '100%', pb: 1 }} />}
          {isLoadingGames ? (
            <Grid container spacing={2}>
              {[...Array(6).keys()].map((x, pIdx) => (
                <Grid key={pIdx} item xl={2} lg={2} md={2} sm={4} xs={3}>
                  <Skeleton variant="rounded" sx={{ borderRadius: 1 }} width={'100%'} height={150} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Stack spacing={2}>
              {popularGames?.data?.length > 0 && (
                <Box id={'Popular'} sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT }}>
                  {/* <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        background: 'linear-gradient(273.4deg, rgba(3, 0, 165, 0) 12.81%, #0467FC 96.52%)',
                        mb: 2,
                        borderRadius: '5px',
                        p: 0.5,
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Image
                          src={require('../../assets/menu/popular.png')}
                          alt="All Games"
                          sx={{ width: '25px', height: 'auto', mr: '4px', cursor: 'pointer' }}
                        />
                        <Typography sx={{ fontWeight: 500 }}>{translate('popular')}</Typography>
                      </Box>
                      <Link sx={{ color: 'turquoise', fontSize: '0.8rem' }} onClick={() => navigate('/games/popular')}>
                        {translate('show_all')}
                      </Link>
                    </Box> */}

                  <SectionHeader>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <SectionIconWrapper>
                        {/* <Image src={require('../../assets/menu/popular.png')} sx={{ width: '100%' }} /> */}
                        <Iconify icon={'mdi:fire'} sx={{ fontSize: { xs: '23px', sm: '2rem' } }} />
                      </SectionIconWrapper>
                      <SectionTitle>{translate('popular')}</SectionTitle>
                    </Box>
                  </SectionHeader>
                  <Grid container spacing={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
                    {popularGames?.data?.map((g, gIndex) => (
                      <Grid key={gIndex} item xl={2} lg={2} md={2} sm={4} xs={4}>
                        <GameContainer item={g} titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }} hasShadow />
                      </Grid>
                    ))}

                    {/* {parseFloat(popularGamesTotal) > popularGames?.data.length && (
                    <Grid item xs={12}>
                      <LoadingButton
                        sx={{
                          background: '#c7fe27',
                          color: '#009115',
                          fontSize: '14px',
                          fontWeight: 600,
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          display: 'flex',
                          '&:hover': {
                            background: '#00AB55 !important',
                          },
                        }}
                        variant="contained"
                        color="inherit"
                        loading={isLoadingPopGames}
                        disabled={isLoadingPopGames}
                        onClick={() => getPopularGames()}
                      >
                        {translate('more_x_of_y', { x: popularGames?.data.length, y: popularGamesTotal })}
                      </LoadingButton>
                    </Grid>
                  )} */}
                  </Grid>
                </Box>
              )}
            </Stack>
          )}
        </>
      ) : (
        <>
          <Box
            key={selectedCompanyCateg.slug}
            id={selectedCompanyCateg.slug}
            sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT }}
          >
            <SectionHeader>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <SectionIconWrapper>
                  <Image src={getGameCategIcon(selectedCompanyCateg?.slug)?.src} sx={{ width: '100%' }} />
                </SectionIconWrapper>
                <SectionTitle>{selectedCompanyCateg?.name}</SectionTitle>
              </Box>
            </SectionHeader>

            <Grid container spacing={2}>
              {selectedCompanyCateg.companies.map((g, gIndex) => (
                <Grid key={gIndex} item xl={2} lg={2} md={2} sm={4} xs={4}>
                  <GameContainer
                    item={g}
                    companySlug={selectedCompanyCateg?.slug}
                    // containerSx={{
                    //   background:
                    //     'linear-gradient(0deg, rgba(1,161,1,1) 0%, rgba(1,161,1,1) 90%, rgba(178,255,1,1) 100%)',
                    // }}
                    // imgWrapperSx={{ width: '100px', minHeight: '140px' }}
                    titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }}
                    hasShadow
                    isProvider
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}

      {/* {gameCategsAndCompanies.map((item) => (
            <Box key={item.slug} id={item.slug} sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT }}>
              <SectionHeader>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <SectionIconWrapper>
                    <Image src={getGameCategIcon(item?.slug)?.src} sx={{ width: '100%' }} />
                  </SectionIconWrapper>
                  <SectionTitle>{item?.name}</SectionTitle>
                </Box>
              </SectionHeader>

              <Grid container spacing={2}>
                {item.companies.map((g, gIndex) => (
                  <Grid key={gIndex} item xl={2} lg={2} md={2} sm={4} xs={4}>
                    <GameContainer
                      item={g}
                      companySlug={item?.slug}
                      // containerSx={{
                      //   background:
                      //     'linear-gradient(0deg, rgba(1,161,1,1) 0%, rgba(1,161,1,1) 90%, rgba(178,255,1,1) 100%)',
                      // }}
                      // imgWrapperSx={{ width: '100px', minHeight: '140px' }}
                      titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }}
                      hasShadow
                      isProvider
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            // {item.page.total_data > item.showCount && (
            //   <LoadingButton
            //     sx={{
            //       background: '#c7fe27',
            //       color: '#009115',
            //       fontSize: '14px',
            //       fontWeight: 600,
            //       marginLeft: 'auto',
            //       marginRight: 'auto',
            //       display: 'flex',
            //       marginTop: '12px',
            //       '&:hover': {
            //         background: '#00AB55 !important',
            //       },
            //     }}
            //     variant="contained"
            //     color="inherit"
            //     loading={isLoadingMoreKey === item?.key}
            //     disabled={isLoadingMoreKey === item?.key}
            //     onClick={() => handleLoadMore(item.key)}
            //   >
            //     {translate('more_x_of_y', { x: item.showCount, y: item.page.total_data })}
            //   </LoadingButton>
            // )}
          ))} */}

      {!selectedCompanyCateg ? (
        <Stack spacing={1} sx={{ mt: 2 }}>
          <SectionHeader>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <SectionIconWrapper>
                {/* <Image src={require('../../assets/menu/leaderboard.png')} sx={{ width: '100%' }} /> */}
                <Iconify icon={'mingcute:trophy-fill'} sx={{ fontSize: { xs: '23px', sm: '2rem' } }} />
              </SectionIconWrapper>
              <SectionTitle>{translate('leaderboard')}</SectionTitle>
            </Box>
          </SectionHeader>
          <HomeLeaderboard />
        </Stack>
      ) : (
        ''
      )}
    </>
  );
};

export default HomeBody;
